import { render, staticRenderFns } from "./CookiePolicy.vue?vue&type=template&id=6006db1a"
import script from "./CookiePolicy.vue?vue&type=script&lang=js"
export * from "./CookiePolicy.vue?vue&type=script&lang=js"
import style0 from "./CookiePolicy.vue?vue&type=style&index=0&id=6006db1a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.servis.leaseplan.cz/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6006db1a')) {
      api.createRecord('6006db1a', component.options)
    } else {
      api.reload('6006db1a', component.options)
    }
    module.hot.accept("./CookiePolicy.vue?vue&type=template&id=6006db1a", function () {
      api.rerender('6006db1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/CookiePolicy.vue"
export default component.exports